import {Component,Inject, Input, EventEmitter, Output} from 'ng-metadata/core';
import { ChangeLangService } from './changeLang.service';
import {getAttributesMap, getRtlLanguages, getVid} from '../../appConfig/appConfigForward';
//your imports go here
import {PrimolyticsService,beacon} from '../../analytics/primolytics.service';
import {JwtUtilService} from '../../security/jwtUtil.service';
import {UserSessionManagerService} from '../../security/userSessionManager.service';


@Component({
    selector: 'prm-change-lang',
    templateUrl: 'components/infra/lang/change-lang.html',
})

export class PrmChangeLang{
    @Input() private labelType:string;

    @Output() private changeLangEvent: EventEmitter<Object>= new EventEmitter();

    private _selectedLanguage: string;
    private languages:string[];
    private attributesMap = getAttributesMap();
    private vid = getVid();
    private rtlLanguages = getRtlLanguages();

    /* input fields */

    constructor(private changeLangService: ChangeLangService,
                @Inject('I18nService') private i18nService,
                private jwtUtilService: JwtUtilService,
                private userSessionManagerService: UserSessionManagerService,
                @Inject('$state') private $state: ng.ui.IStateService,
                @Inject('topBarIcons') private topBarIcons,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                private primolyticsService: PrimolyticsService) {
        this.selectedLanguage =  i18nService.getLanguage();
        this.languages = this.attributesMap.interfaceLanguageOptions.split(',');
        this.changeLangService.addLangParamToUrl(this.selectedLanguage);
        this.setPageLanguage(this.selectedLanguage);

    }

    private setPageLanguage(selectedLanguage){
        let htmlRoot = <HTMLLinkElement>document.getElementById('primoExploreRoot');
        // since java Locale has a legacy problme wit hthe following code we will replace them manually
        let javaLocaleFixer = {iw: 'he',ji: 'yi', in: 'id'};
        if(htmlRoot && selectedLanguage && selectedLanguage.length >= 2) {
            let code = selectedLanguage.substring(0, 2);
            if(javaLocaleFixer[code]){
                code = javaLocaleFixer[code];
            }
            htmlRoot.setAttribute('lang', code);
            let direction;
            if(this.rtlLanguages.has(code)) {
                direction = 'rtl';
            }
            else {
                direction = 'ltr';
            }
            this.changeLangService.direction= direction;
            htmlRoot.setAttribute('dir', direction);

        }
    }

    private get selectedLanguage() {
        return this._selectedLanguage;
    }

    private set selectedLanguage(selectedLanguage) {
        this._selectedLanguage = selectedLanguage;
    }

    /* tslint:disable  no-unused-variable  */
    private getLabelType() {
        return this.labelType;
    }


    @beacon({'p':'general', 'op':'changeLanguage'})
    private changeLanguage() {

        this.changeLangService.addLangParamToUrl(this.selectedLanguage);
        if (this.jwtUtilService.getDecodedToken().userGroup !== 'GUEST'){
            let updateUserLanguagePromise = this.changeLangService.updateUserLanguage(this.vid,this.selectedLanguage);
            updateUserLanguagePromise.then((response)=>this.successAction(response));
        }

        return this.i18nService.setLanguage(this.selectedLanguage).then(()=> {
            this.changeLangEvent.emit({lang: this.selectedLanguage });
            // the timeout have been added to fix this: PRM-35152
            this.$timeout(()=>{
                return this.$state.go(this.$state.current, {lang: this.selectedLanguage}, {reload: true});
            })
        });

    }
    /* tslint:enable  no-unused-variable  */

    private successAction(response) {
        this.userSessionManagerService.syncJwtWithTabs(response.data);
        this.jwtUtilService.storeJwt(response.data);
    }



}


// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/lang/changeLang.directive.ts